// extracted by mini-css-extract-plugin
var _1 = "BlueLabel__bg--qPlLx";
var _2 = "BlueLabel__clickable--RSnlz";
var _3 = "BlueLabel__disabled--jzkHZ";
var _4 = "BlueLabel__disabledBg--ZWtP5";
var _5 = "BlueLabel__image--sgPgR";
var _6 = "BlueLabel__quadPadding--eyyzw";
var _7 = "BlueLabel__quadWrapper--BtrZz";
var _8 = "BlueLabel__text--cxcXk CoreGeneral__robotoSlab--X8lgW";
export { _1 as "bg", _2 as "clickable", _3 as "disabled", _4 as "disabledBg", _5 as "image", _6 as "quadPadding", _7 as "quadWrapper", _8 as "text" }
